const profile = {
  title: "Mijn Profiel",
  premiumBtn: "Ga premium",
  orderInfoTitle: "Account toestemming info.",
  tableProduct: "Product",
  tableStatus: "Toestand",
  tablePermissionDate: "Toestemmingsdatum",
  tableValidPeriod: "Geldig Periode",
  validStauts: "Geldig",
  expiredStauts: "Verlopen",
  noData: "Geen gegevens",
};

export default profile;
